export default class EmailConversationStatusChangedEvent {

    constructor(type, conversation) {
        this.type = type;
        this.conversation = conversation;
    };
}

EmailConversationStatusChangedEvent.STATUS_CHANGED = "EmailConversationStatusChangedEvent.STATUS_CHANGED";